import { Button, Stack, Typography } from '@mui/material';

import ContinueAndPreviewContainer from 'components/v2/container/ContinueAndPreviewContainer';
import { ArrowRightIcon } from 'components/v2/icons/ArrowRightIcon';
import { LAYOUT_SPACING } from 'constants/ui/style';
import NewPreviewReceipt from '../receipt/NewPreviewReceipt';
import CollapsibleSection from 'components/v2/accordion/CollapsibleSection';
import DataGridTable from 'components/v2/table/DataGridTable';
import { useCreateNewOrderStep3 } from 'hooks/services/useCreateNewOrderStep3';
import SkeletonContainer from 'components/v2/container/SkeletonContainer';
import Show from 'components/v2/show/Show';

const CreateOrderStep3 = () => {
  const {
    t,
    ui,
    isLoading,
    groupedPackages,
    handleSelectionChange,
    onNext,
    handleRowSelectionModelChange,
    totalPrice,
    apiState,
  } = useCreateNewOrderStep3();

  return (
    <Stack direction="row" justifyContent="space-between" sx={{ height: '100%' }}>
      <Stack
        spacing={LAYOUT_SPACING.CARD.md}
        sx={{ width: '100%', padding: '1rem 1rem 1rem 0', overflowY: 'auto' }}
        mb={{ xs: 10, md: 0 }}
      >
        <SkeletonContainer columns={{ xs: 1 }} rows={{ xs: 3 }} loading={isLoading} skeletonHeight={250}>
          <Show
            when={Object.keys(groupedPackages).length > 0}
            fallback={
              <Stack justifyContent="center" alignItems="center" sx={{ height: '100%' }}>
                {t('common.terms.noData')}
              </Stack>
            }
          >
            {Object.entries(groupedPackages).map(([categoryId, group], index) => (
              <CollapsibleSection key={index + 1} title={group.name} defaultOpen={index === 0}>
                <DataGridTable
                  rows={group.rows}
                  columns={ui.table.columns}
                  isHideFooter
                  loading={isLoading}
                  checkboxSelection
                  sx={{ minHeight: '12rem' }}
                  onRowSelectionModelChange={handleSelectionChange(categoryId, group.rows)}
                  rowSelectionModel={handleRowSelectionModelChange(categoryId)}
                  disableMultipleRowSelection
                />
              </CollapsibleSection>
            ))}
          </Show>
        </SkeletonContainer>
      </Stack>

      <ContinueAndPreviewContainer
        continueElement={
          <Stack gap={2}>
            {apiState?.showPrice && (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ display: { xs: 'none', sm: 'flex' } }}
              >
                <Typography variant="h5">{t('common.terms.totalPrice')}</Typography>
                <Typography variant="h5" fontWeight={600}>
                  {totalPrice}
                </Typography>
              </Stack>
            )}

            <Button
              size="large"
              variant="contained"
              disabled={isLoading}
              fullWidth
              endIcon={<ArrowRightIcon />}
              onClick={onNext}
            >
              {t('common.terms.continue')}
            </Button>
          </Stack>
        }
        previewElement={<NewPreviewReceipt />}
      />
    </Stack>
  );
};

export default CreateOrderStep3;
